var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoReqHistoryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 124,
    viewBox: "0 0 120 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1854_25108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99988 122.009L36.5383 40.3721H82.4037L114 122.009H7.99988Z",
    fill: "url(#paint0_linear_1854_25108)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M33.3366 28.2225C33.2524 16.5003 45.0047 6.94726 59.5371 6.86383C74.0696 6.7804 85.9483 16.2082 85.9904 27.8888L33.3366 28.2225Z",
    fill: "#EABBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2886 27.8894C44.2465 19.8381 51.5759 13.247 60.7166 13.2053C69.8573 13.1636 77.2709 19.6296 77.313 27.7225L44.2886 27.8894Z",
    fill: "url(#paint1_linear_1854_25108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3364 28.2224L19.141 33.6455L99.975 33.1866L86.285 27.8887L33.3364 28.2224Z",
    fill: "url(#paint2_linear_1854_25108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.184 33.1716L16.7967 33.7009C15.806 33.707 15.0079 34.515 15.014 35.5057C15.0202 36.4964 15.8283 37.2946 16.8189 37.2885L103.206 36.7592C104.197 36.7531 104.995 35.9451 104.989 34.9544C104.983 33.9637 104.175 33.1655 103.184 33.1716Z",
    fill: "#5D5189"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2246 44.4499C42.2246 44.4499 24.7015 40.7789 20.2365 37.233L46.4369 37.0662L99.4698 36.7324C99.4698 36.7324 88.1387 44.3665 77.5658 44.2413C77.5658 44.2413 77.4394 47.8289 73.3114 47.8289C69.1833 47.8706 46.7739 47.9958 46.7739 47.9958C46.7739 47.9958 41.677 47.1615 41.677 44.3248",
    fill: "url(#paint3_linear_1854_25108)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M61.8115 13.1631C61.8115 13.1631 70.9943 18.7531 67.4139 27.722L75.7963 27.6803C75.7963 27.6803 75.4172 15.6661 61.8115 13.1631Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M47.3635 24.4686C47.3214 24.3017 47.2793 24.1348 47.2793 23.968C47.1108 20.9644 50.944 16.2088 54.0611 15.9585C55.2827 15.875 56.757 17.0014 56.0409 18.2946C55.1142 20.0049 53.9347 21.5484 52.7132 23.0502C51.8286 24.1765 50.6913 26.1372 48.9642 25.7618C48.206 25.6366 47.6163 25.1777 47.3635 24.4686Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M59.579 24.1344C59.579 25.3024 58.6523 26.2619 57.4307 26.2619C56.2513 26.2619 55.2825 25.3441 55.2825 24.1344C55.2825 22.9663 56.2092 22.0068 57.4307 22.0068C58.6102 22.0486 59.579 22.9663 59.579 24.1344Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5041 34.6629L17.0244 34.7147C16.6558 34.7169 16.3588 35.0176 16.3611 35.3862C16.3634 35.7548 16.6641 36.0518 17.0327 36.0496L25.5124 35.9978C25.8811 35.9956 26.178 35.6949 26.1757 35.3263C26.1734 34.9577 25.8728 34.6607 25.5041 34.6629Z",
    fill: "url(#paint4_linear_1854_25108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3315 34.663L31.8518 34.7147C31.4832 34.7169 31.1862 35.0176 31.1885 35.3862C31.1908 35.7548 31.4915 36.0518 31.8601 36.0496L40.3398 35.9979C40.7084 35.9957 41.0054 35.695 41.0031 35.3264C41.0008 34.9578 40.7001 34.6608 40.3315 34.663Z",
    fill: "url(#paint5_linear_1854_25108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.201 34.663L46.7213 34.7147C46.3527 34.7169 46.0557 35.0176 46.058 35.3862C46.0603 35.7548 46.361 36.0518 46.7296 36.0496L55.2093 35.9979C55.5779 35.9957 55.8749 35.695 55.8726 35.3264C55.8703 34.9578 55.5697 34.6608 55.201 34.663Z",
    fill: "url(#paint6_linear_1854_25108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0289 34.705L61.5492 34.7567C61.1805 34.7589 60.8836 35.0596 60.8859 35.4282C60.8882 35.7968 61.1888 36.0938 61.5575 36.0916L70.0372 36.0399C70.4058 36.0376 70.7028 35.737 70.7005 35.3684C70.6982 34.9997 70.3975 34.7027 70.0289 34.705Z",
    fill: "url(#paint7_linear_1854_25108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8984 34.58L76.4187 34.6317C76.0501 34.6339 75.7531 34.9346 75.7554 35.3032C75.7577 35.6718 76.0583 35.9688 76.427 35.9666L84.9067 35.9149C85.2753 35.9126 85.5723 35.612 85.57 35.2434C85.5677 34.8747 85.267 34.5777 84.8984 34.58Z",
    fill: "url(#paint8_linear_1854_25108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7262 34.4549L91.2464 34.5067C90.8778 34.5089 90.5808 34.8096 90.5831 35.1782C90.5854 35.5468 90.8861 35.8438 91.2547 35.8416L99.7345 35.7899C100.103 35.7876 100.4 35.4869 100.398 35.1183C100.395 34.7497 100.095 34.4527 99.7262 34.4549Z",
    fill: "url(#paint9_linear_1854_25108)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 61,
    cy: 120.414,
    rx: 30,
    ry: 4,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 57,
    width: 54,
    height: 54,
    rx: 16,
    fill: "url(#paint10_linear_1854_25108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5738 74.6659H55.4363C54.5682 74.6659 53.8638 73.9615 53.8638 73.0934V70.6975C53.8638 69.8294 54.5682 69.125 55.4363 69.125H64.5738C65.4418 69.125 66.1463 69.8294 66.1463 70.6975V73.0934C66.1463 73.9626 65.4418 74.6659 64.5738 74.6659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0738 71.8984H67.7404V73.0938C67.7404 74.8394 66.3198 76.26 64.5741 76.26H55.4366C53.6899 76.26 52.2704 74.8394 52.2704 73.0938V71.8984H50.9475C48.8438 71.8984 47.1438 73.5984 47.1438 75.7022V95.0716C47.1438 97.1753 48.8438 98.8753 50.9475 98.8753H69.0525C71.1563 98.8753 72.8563 97.1753 72.8563 95.0716V75.7022C72.8563 73.5878 71.1775 71.8984 69.0738 71.8984ZM58.351 87.6585H53.7419C53.2139 87.6585 52.7857 87.2303 52.7857 86.7022C52.7857 86.1742 53.2139 85.746 53.7419 85.746H58.351C58.8791 85.746 59.3073 86.1742 59.3073 86.7022C59.3073 87.2303 58.8791 87.6585 58.351 87.6585ZM63.995 82.2313H53.7419C53.2139 82.2313 52.7857 81.8031 52.7857 81.275C52.7857 80.7469 53.2139 80.3187 53.7419 80.3187H63.994C64.5221 80.3187 64.9502 80.7469 64.9502 81.275C64.9502 81.8031 64.5231 82.2313 63.995 82.2313Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1854_25108",
    x1: 60.9999,
    y1: 40.3721,
    x2: 60.9999,
    y2: 122.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1854_25108",
    x1: 60.8007,
    y1: 13.2051,
    x2: 60.8007,
    y2: 27.8894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#973BA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF53FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1854_25108",
    x1: 59.558,
    y1: 27.8887,
    x2: 59.558,
    y2: 33.6455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAADEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDE8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1854_25108",
    x1: 68,
    y1: 48.2,
    x2: 68,
    y2: 36.2531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAADEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDE8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1854_25108",
    x1: 16.3629,
    y1: 35.6761,
    x2: 26.1775,
    y2: 35.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C61CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1854_25108",
    x1: 31.1903,
    y1: 35.6761,
    x2: 41.0049,
    y2: 35.6151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C61CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1854_25108",
    x1: 46.0598,
    y1: 35.6761,
    x2: 55.8744,
    y2: 35.6151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C61CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1854_25108",
    x1: 60.8877,
    y1: 35.7181,
    x2: 70.7023,
    y2: 35.6571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C61CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1854_25108",
    x1: 75.7572,
    y1: 35.5931,
    x2: 85.5718,
    y2: 35.5321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C61CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1854_25108",
    x1: 90.5849,
    y1: 35.4681,
    x2: 100.4,
    y2: 35.4071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C61CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1854_25108",
    x1: 60,
    y1: 57,
    x2: 60,
    y2: 113.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E600EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9002FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1854_25108"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 124,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoReqHistoryIcon);
export default __webpack_public_path__ + "static/media/no-req-history-icon.6964b83fbe216680fca0ca83e58a487f.svg";
export { ForwardRef as ReactComponent };